<script>
import { onMounted } from 'vue';
import Grid from '../../common/components/Grid.vue';
import GridItem from '../../common/components/GridItem.vue';
import Testimonies from '../../component/testimonies/Testimonies.vue';
import Highlights from '../../component/highlights/Highlights.vue';
import Newsfeed from '../../common/components/Newsfeed.vue';

export default {
  name: "PageHubOffres",
  components: {
    Testimonies,
    Highlights,
    Grid,
    GridItem,
    Newsfeed,
  },
  setup() {

    // Mise à jour du Swiper après le montage
    onMounted(() => {
    });

    return {
    };
  },
};
</script>

<style lang="sass">
@import '../../common/styles/settings'
@import '../../common/styles/mixins'
@import 'node-hub-offres'
</style>
